module.exports = __webpack_public_path__ + "img/vignettes-asso_0013_lazare.aab4cca5.jpg";